import { 
  CLEAR_ADMIN_AUDIT_SEARCH,
  SELECT_ADMIN_AUDIT_TAB
} from './constants';

export const clearAdminAuditSearch = () => ({
  type: CLEAR_ADMIN_AUDIT_SEARCH,
  payload: null
});
 
export const selectAuditTab = (auditTab) => ({
  type: SELECT_ADMIN_AUDIT_TAB,
  payload: auditTab
});


// WEBPACK FOOTER //
// ./src/features/admin/audit/actionTypes.js